import ControlsColl from './model/Controls';
import ControlListView from './view/ControlListView';
import GConfig from '../../config/config';
import defaults from './config/config';
import CommonFunction from '../common/common';
import { cmpPos } from 'codemirror';

const url = GConfig.url;

export default () => {
  let em;
  var c = {};
  var Controls, view;
  var success = function(data) {
    if (typeof data == 'string') {
      var index = data.indexOf(
        'Object reference not set to an instance of an object'
      );
      if (index > -1) {
        $('.error-loading').removeClass('hide');
        return false;
      }
    }
    var controlsMeta = JSON.parse(JSON.parse(data)['controls']);
    var status = JSON.parse(JSON.parse(data)['status']);
    controlsMeta = CommonFunction.merge_object_arrays(
      controlsMeta,
      status,
      'control_id'
    );
    controlsMeta = controlsMeta.sort(function(a, b) {
      return a['control_id'] - b['control_id'];
    });
    controlsMeta = controlsMeta.filter(control => control['isFromDesigner']);
    Controls = new ControlsColl(controlsMeta);
    view = new ControlListView({
      collection: Controls,
      config: c,
      gconfig: GConfig
    });
    return true;
  };

  var error = function(error) {
    if (data.status == 401) {
      $('.studio-loader')
        .find('.error-loading')
        .removeClass('hide');
    }
  };

  return {
    /**
     * Name of the module
     * @type {String}
     * @private
     */
    name: 'ControlManager',

    /**
     * Initialize module. Automatically called with a new instance of the editor
     * @param {Object} config Configurations
     * @return {this}
     * @private
     */
    init(config) {
      c = config || {};
      for (var name in defaults) {
        if (!(name in c)) c[name] = defaults[name];
      }
      em = c.em;
      var ajaxUrl = url + 'Handler/ControlEditorHandler.ashx';
      var data = {
        operation: 'GetStudioControlsListForEditor'
      };
      var controlListSucces = function(data) {
        if (success(data)) {
          CommonFunction.hideLoader();
          var parameter = new URLSearchParams(window.location.search);
          if (parameter.get('id')) {
            this.openControl(parameter.get('id'));
          } else {
            this.openConrolList();
          }
        }
      };
      CommonFunction.fnAjaxRequest(
        ajaxUrl,
        'POST',
        data,
        controlListSucces.bind(this),
        error
      );
      return this;
    },

    /**
     *opens control.
     * @param {int} id
     */
    openControl(id) {
      let ctrlmdl = this.get(id);
      if (ctrlmdl) {
        ctrlmdl.view.opencontrol();
      } else {
        this.openConrolList();
        CommonFunction.ShowVSAlert('error', 'Control not found!');
      }
    },
    /**
     * Return device by name
     */
    get(id) {
      return Controls.get(id.toString());
    },

    /**
     * return all controls collection;
     */
    getAll() {
      return Controls;
    },

    /**
     * refreshes the contorl lisnting form database
     */
    refreshList(id = null) {
      this.closeControlList();
      Controls = null;
      view = null;
      var ajaxUrl = url + 'Handler/ControlEditorHandler.ashx';
      var data = {
        operation: 'GetStudioControlsListForEditor'
      };
      var controlListSucces = function(data) {
        if (success(data)) {
          CommonFunction.hideLoader();
          this.openControl(id);
        }
      };
      if (id) {
        CommonFunction.showLoader();
        CommonFunction.fnAjaxRequest(
          ajaxUrl,
          'POST',
          data,
          controlListSucces.bind(this),
          error
        );
      } else {
        CommonFunction.fnAjaxRequest(ajaxUrl, 'POST', data, success, error);
      }
    },

    /**
     * opens control listing
     * @return {string} HTML string
     * @private
     */
    openConrolList() {
      this.closeControlList();
      $('body').append(view.render().$el);
    },

    /**
     * closes the control listing
     */
    closeControlList() {
      view.remove();
    }
  };
};
